export default "__VITE_ASSET__DBrZEzCR__"